export function testGJC() {
  return {
    methods: {
      /**
       * 模拟的数据
       * @returns
       */
      getWords() {
        return [
          {
            zhu: "主攻 新疆 下官坊",
            fu: "突出 工作 甘沟村 ",
            ci: "重点 大学 双槽路 局寺路",
          },
          {
            zhu: "天津",
          },
        ];
      },
      /**
       *  关键字的规则
       * @param {每一组关键字} objItem
       * @returns 将关键字解码后的造型
       */
      runWordObj(objItem) {
        const TextList =
          Object.values(objItem).map((Texts) => Texts.split(" ")) || [];
        const [zhuList = [], fuList = ["-*-"], ciList = ["-*-"]] = TextList;
        let strArray = [];
        for (let i = 0; i < zhuList.length; i++) {
          for (let j = 0; j < fuList.length; j++) {
            for (let k = 0; k < ciList.length; k++) {
              let strArr = [zhuList[i]];
              if (fuList[j] && fuList[j] !== "-*-") strArr.push(fuList[j]);
              if (ciList[k] && ciList[k] !== "-*-") strArr.push(ciList[k]);
              strArray = [...strArray, strArr];
            }
          }
        }
        return strArray;
      },
      /**
       * 获取每一组的关键字编码规则
       * @param {} listArrs
       * @returns
       */
      runWord_fn(listArrs) {
        const returnWordList = listArrs.reduce(
          (pre, list) => [...pre, ...this.runWordObj(list)],
          []
        );
        return returnWordList;
      },
      /**
       * 拿列表去匹配
       * @param {} text
       * @param {*} wantData
       * @returns
       */
      m_runText(text = "", wantData = []) {
        const someElm = wantData.some((list) => {
          const everyElm = list.every((element) => text.includes(element));
          return everyElm;
        });
        return someElm;
      },
      /**
       * 用关键字的规则去匹配每一条数据
       */
      m_chuliList(listData) {
        const WordsData = this.getWords(); // 关键词 主 副 次
        const wantData = this.runWord_fn(WordsData); // 这是关键字规则 做造型
        // 拿列表去匹配
        const wangList = listData.filter(
          (item, inx) =>
            this.m_runText(item.title, wantData) ||
            this.m_runText(item.content, wantData)
        );
      },



      // 第二种
      m_chuliList2(listData) {
        const WordsData = this.getWords2(); // 关键词 主 副 次
        // // 拿列表去匹配
        //  let startTime=new Date().getTime()
         let text=`序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
         序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
         序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。序言青春是一条奔腾的河，是一条充满惊涛骇浪的河：青春 是一座高耸的山， 是一座看不见路径的山。 前面的路有高山， 就难免会有毒蛇猛兽出没：也免不了有“野芳发而幽香，佳 木秀而繁阴。 ”前提：我，刘伟琦，今年 25 岁，在一家外企做着销售部经理一职。小白领一个，生活挺惬意。白天坐在办公室 前敲几下键盘，打几个电话。累了就去咖啡间里品着咖啡。 晚上就和三五朋友打打篮球喝喝酒，天天如此。直到„„ 第一章：“刘总，这是上个月公司的销售业绩。“好，我看看。 ” ” “那，刘总，没什么事我先下班了。“行，路上小心点，拜 ” 拜。 ”我坐在电脑桌前审核着上一个月的公司业绩，突然放 在桌子上的手机响了，手机屏幕上显示着“老妈”“喂，妈， 。 怎么了？” “儿子，今晚回家吃饭吧！今天是你生日。 ”我看 看手表还真是，六月三日。哎！又忙忘了！ “知道了妈，今 天忙完了就回去。 ”按死了电话，看了看时间，五点半了。 我看完了业绩表， 按死了电脑， 拿着手机就乘着电梯下了楼。 坐上车，打开广播，发动车走了„„ 这个点虽说车不算多，但也不少。堵在路上，把着方向 盘，看着外面灯火辉煌的城市。 “主人、主人，李成荣来电话了。 ”这李成荣——是我初中同学，我们俩是铁哥们。他 现在是做电子工业的，是他们行业的龙头大哥，高富帅也就 是形容他这种人吧。他初中就一直追我们班一个女生，他这 个“重色轻友”的家伙，25 岁事业，家庭什么都有了。 “干 嘛呢伟琦？今晚一起出去吧！今天是你生日，咱哥俩好好聊 聊吧！“成荣，今天就算了吧，我今天有事，明天吧！我一 ” 定奉陪。 “你这家伙，怎么这么难请？” ” “不是，今晚我要 回家，我已经和我妈约好了，明天吧，嗯” “行吧，伟琦， 明天你可要付账了！就这样，拜拜。 “拜。 ” ”挂了电话，刚 准备放下，手机铃声又响了。 “妈，怎么了？” “哪时回来？ 菜都做好了。 “妈，堵车，行„„拜。 ” ”扣死电话，开着车 一路奔驰，经过十分多钟的奔波，我终于到了楼下。 “叮、 叮。 ”我气喘吁吁的靠在门上。住这么高楼干嘛，14 层楼， 电梯又坏了，够点背的。 “砰，门开了。妈，我来了。“来， ” 进来吧。 ” „„„„ 我就知道肯定离不开那个话题，果然不出我所料，吃了 能有 20 分钟，我妈又开始啰里啰嗦。 “伟琦呀！你今年也 25 岁了，你看看你铁哥们李成荣，和你一样大，却家庭事业两 丰收。你呢？25 了，一个对象也没谈过，你也不„„” “哎！ 妈。你能不能不‘哪壶不开提哪壶’ ，我才 25 岁呢，早呢！ 是我的早就来了，不是我的也强求不来！妈，时间也不早了，
         我还有事，我先走了。 ”我提着公文包夺门而逃，身后回荡 着我妈的呼喊声。 不觉外面开始雷雨轰鸣，一会淅沥沥的下起了小雨。是 呀，妈说的没错，我也老大不小，怎么就没一个女朋友呢？ 想到这，不觉心里空落落的。 “喂，张总，我小刘。我想休 我今年的年假， 我想去外地休息一个月。 谢了张总， ” 行， 拜。 “喂，李成荣，是兄弟不？（这四个字是我在初中要挟他帮 我忙时说的， 不成想 11 年后， 我又再一次的说起这四个字） ” “李伟琦， 你又有什么任务？这四个字你已经„„11 年没说 了，咋了，现在说有啥目的？” “李成荣，我想出国旅游， 你也请个假，陪哥们我出去溜溜！“没问题，哥们我随时奉 ” 陪。哪天走？去哪呀？” “明天就走，去哪吗？我还没想好， 等到飞机场再说。对了，嫂子去不去？” “他一定要去，再 怎么着，我也追了她 3 年，还没真真正正的陪她出去度蜜月 呢！这次就当补偿吧！“唉！ ” ”我不由得叹息道。 “叹啥气， 不就没女朋友吗，怕啥！等回来兄弟该你介绍几个。 ”这么 多年了，还是你老李最懂我！ “你和嫂子今晚好好收拾，明 天 9：00 到机场集合，拜。 ” 扣死电话，我也开着车往家疾驰。30 分钟后到家，我开 始漫无目的的收拾着
         
         
         --------------------------------------------------------
         作者：520gghhhj
         链接：https://wenku.baidu.com/view/afff6718a76e58fafab00308.html
         来源：百度文库
         著作权归作者所有。商业转载请联系作者获得授权，非商业转载请注明出处。
         `
         console.time('speed')
        const wangList = listData.filter(
          (item, inx) =>
            this.m_runText2(text, WordsData) ||
            this.m_runText2(text, WordsData)
        );
        // console.log("速度:",new Date().getTime()-startTime);
        console.log("用户输入", WordsData);

        console.log("匹配的", wangList);
        console.timeEnd('speed')
      },
    //   匹配规则
      m_runText2(text = "", wantData = []) {
        return wantData.some((list) => {
          return list.every((itms) => {
            return itms.some((vvv) =>{
                const niubi =  text.includes(vvv)
                if(niubi) console.log(vvv)
                return niubi;
            } );
          });
        });
      },
    //   关键字
      getWords2() {
        return [
          [
            [
               
                '青春',
                "索贿",
                "受贿",
                "贿赂",
                "行贿",
                "摄入",
                "贪污",
                "消息",
                "大贪",
                "贪官",
                "腐败",
                "巨贪",
                "巨贿",
                "不作为",
                "利用职权",
                "职权之便",

                "职权谋取",
                "职权牟取",
                "滥用权利",
                "贪污公款",
                "职权获利",
                "公款提成",
                "公款私用",

                "受处分",
                "巨额财产",
                "打击报复",
                "落马",
                "贪巨款",
                "挪用",
                "渎职",
                "不正之风",
                "严肃执纪",
                "义利观",
                "乱发钱物",
                "以权谋私",
                "优亲厚友",
                "依规治党",
                "侵害群众",
                "切身利益",
                "开除党籍",
                "党纪",
                "国法",
                "公私观",
                "包案协调",
                "包案查办",
                "包案督办",
                "公款旅游",
                "吃空饷",
                "合理诉求",
                "四风",
                "失职",
                "巡视组",
                "工作作风",
                "带案下访",
                "廉政建设",
                "思想政治洗礼",
                "执行不力",
                "政绩观",
                "典治乱",
                "铁包公",
                "集体资金案",
                "不为百姓",
                "中饱私囊",
                "买官",
                "卖官",
                "跑官",
                "作风",
                "保护伞",
                "倡廉",
                "公权",
                "公款",
                "勾结",
                "包庇",
                "双开",
                "双规",
                "吃拿",
                "大操大办",
                "官商",
                "官场",
                "官官相卫",
                "官官相护",
                "小金库",
                "廉政",
                "徇私",
                "情妇",
                "拿好处",
                "推诿",
                "收受",
                "暗箱操作",
                "潜规则",
                "空饷",
                "纵容亲属",
                "纵容配偶",
                "职务之便",
                "职权",
                "腐化",
                "草芥人命",
                "营私",
                "要官",
                "谋取私利",
                "贪官",
                "走形式",
                "越权",
                "违纪",
                "违规",
                "鱼肉百姓",
                "被免职",
                "包二奶",
                "包养情人",
                "包养情妇",
                "报假帐",
                "暴力取证",
                "被调查",
                "被举报",
                "纪委",
                "纪检",
                "干部",
                "被没收粮田",
                "被挖双眼",
                "被指侵占",
                "拨款退税款",
                "敛财",
                "干部戴名表",
                "腐化",
                "公车超标",
                "公务用车",
                "公务车",
                "公车私用",
                "公道何在",
                "公费旅游",
                "政策泄露",
                "官员出场费",
                "捞肥肉",
                "捞钱",
                "捞油水",
                "走穴",
                "虚报冒领",
                "瞒报",
                "谎报",
                "贿选",
                "利用职务",
                "职务便利",
                "职务之便",
                "乱罚款",
                "煤矿非法转让",
                "牟取私利",
                "弄虚作假",
                "骗取国家财政",
                "骗取荣誉",

                "欺压百姓",
                "欺压老百姓",
                "侵犯公私财产",

                "侵吞国有资产",

                "司法不公",
                "违法审批",

                "徇私枉法",
                "营私舞弊",
                "走后门",
                "撤职",
                "选举",
                "投诉政府",
                "有法不依",
                "暴力执法",
                "被查",
                "处分",
                "被罚",
                "开除党籍",
                "被免",
                "被停岗",
                "被停职",
                "被通报",
                "被问责",
                "撤职",
                "粗暴执法",
                "富人特权",
                "工车私用",
                "撤职",
                "富人特权",
                "工车私用",
                "官场灰色",
                "官犯串通",
                "黑幕",
                "黑箱操作",
                "换届乱象",
                "贿买",
                "伪造选票",
                "虚报票数",
                "接受调查",
                "乱作为",
                "瞒报",
                "慢作为",
                "没人管",
                "免职",
                "谋私利",
                "挪巨款",
                "涉嫌滥用",
                "涉嫌私用",
                "涉嫌滥用",
                "涉嫌私用",
                "职务侵占",
                "私放嫌犯",
                "私放疑犯",
                "私分国有资产",
                "贪腐",
                
                "选举乱象",
                "徇私舞弊",
                "玩忽职守",
                "问责",
                "以权压法",
                
                "遭查",
                "遭处罚",
                "遭免",
                "责令",
                "责问",
                "执法不人性",
                
                "检举",
                "遭查办",
                
                "遭撤职",
                "遭处分",
                "雅贿",
                "遭停岗",
                "遭停职",
                "假公济私",
                "局长被爆",
                "局长玩弄女性",
                
                
                "表决权",
                "不称职干部",
                "不合格党员",
                "涉嫌袒护",
                
                "顶风违纪",
                "福利式提拔",
                "干预办案",
                "告状无门",
                "官员变质",
                "官员粗口",
                "官员问责",
                "拉票",
                "权力滥用",
                "权力栽脏",
                "权钱交易",
                "权顷一方",
                "权权交易",
                "权色交易",
                "停职检查",
                "违法办案",
                "违纪办案",
                "选举权",
                "含冤而死",
                "一手遮天",
                "恶霸村长",
                "泄露案情",
                "举报信",
                "利用职务",
                "无证执法",
                
                "大贪官",
                "官商反腐",
                "官匪",
                "官商勾结",
                "官官",
                "官民对峙",
                "领导无能",
                
                "信访部门",
                "公款送礼",
                "依仗权势",
                "严重失职",
                "公款吃喝",
                "公款旅游",
                "不为民做主",
                "民告官",
                "收贿",
                "资产流失",
                "资金挪用",
                "超职数",
                
                "还有王法",
                "违宪",
                "选举",
                "选票",
                "贪赃枉法",
                "挪用公款",
                "换届",
                
                "政府收入",
                "政府被烧",
                "政府黑",
                "政治斗争",
                "政绩差",
                "知法犯法",
                "无案造案",
                
                "滥用公众权利",
                "形象工程",
                "待遇不公",
                "萝卜招聘",
                "告御状",
                "罚款指标",
                "罢免",
                "裸官",
                "国有资产流失",
                "国有资产贱卖",
                "不闻不问",
                "人事震荡",
                "欺压",
                "残害百姓",
                
                "档案造假",
                "百姓心声",
                "监管不利",
                "监管漏洞",
                "视而不管",
                "偷卖资产",
                
                "野蛮执法",
                "有关部门",
                "相关部门",
                
                "政府走形式",
                "表面功夫",
                "殴打群众",
                "通报批评",
                "文件泄露",
                "文件外泄",
                "文件透露",
                "文件走漏",
                "文件被泄",
                
                "政策发布",
                "政策公示",
                "政策公布",
                "政府公告",
                "省委书记",
                "省长",
                "省委常委",
                "市委书记",
                
                
                "市长",
                "市委常委",
                
                "县委书记",
                "县长",
                "区委书记",
                "区长",
                "公款吃喝",
               
                "账务模糊",
                "老虎苍蝇",
                "买官",
                "卖官",
                "腐败分子",
                "染指扶贫",
                "国家财政",
                "吃空饷",
                "弄虚作假",
                "损公肥私",
               
                "徇私舞弊",
                "人情案",
               
                "敛财有方",
                "账务不清",
                "项目缩水",
                "贫困户",
                "侵吞",
                "挪用",
                "腐败黑幕",
                "欺上瞒下",
                "胡作非为",
                "贪官",
                "倒卖",
                "高压线",
                "职务之便",
                "补贴款",
                "以权谋私",
                "财务问题",
                "官官相护",
                "权钱交易",
                "官二代",
                "配套资金",
                "违规提拔",
                "精准扶贫",
                "形同虚设",
                "懒政",
                "不作为",
                "面子工程",
                "百姓呼声",
                "强拆",
                "形同虚设",
                "包庇",
               
                "豪华办公楼",
                "打白条",
                "弱肉强食",
                "形象工程",
                "带病提拔",
                "为所欲为",
                "政府采购",
                "脱贫",
                "扶贫资金",
                "作秀",
                "贫困户",
                "违法违纪",
                "公车私用",
                "为人民服务",
                "人民公仆",
                "结党营私",
                "官僚主义",
                "职务犯罪",
                "暗箱操作",
                "私吞公款",
                "狗官",
                "渎职",
                "脱岗",
                "欺上瞒下",
                "实名举报",
                "三公经费",
                "优亲厚友",
                "吃拿卡要",
                "截留",
                "公款赌博",
                "公款走访",
                "无证执法",
                "扣押物品",
                "非法取缔",
               
                "利用职务之便",
                "公款吃喝",
                "监管不利",
                "滥用公众权利",
                "政府失诚信",
                "不为民做主",
                "执政能力",
                "官僚主义",
                "政绩",
                "拉帮结派",
                "武力镇压",
                "利用职权",
                '滥用职权',
              ],
        
              [
               
                '一条',
                "索贿",
                "受贿",
                "贿赂",
                "行贿",
                "摄入",
                "贪污",
                "消息",
                "大贪",
                "贪官",
                "腐败",
                "巨贪",
                "巨贿",
                "不作为",
                "利用职权",
                "职权之便",

                "职权谋取",
                "职权牟取",
                "滥用权利",
                "贪污公款",
                "职权获利",
                "公款提成",
                "公款私用",

                "受处分",
                "巨额财产",
                "打击报复",
                "落马",
                "贪巨款",
                "挪用",
                "渎职",
                "不正之风",
                "严肃执纪",
                "义利观",
                "乱发钱物",
                "以权谋私",
                "优亲厚友",
                "依规治党",
                "侵害群众",
                "切身利益",
                "开除党籍",
                "党纪",
                "国法",
                "公私观",
                "包案协调",
                "包案查办",
                "包案督办",
                "公款旅游",
                "吃空饷",
                "合理诉求",
                "四风",
                "失职",
                "巡视组",
                "工作作风",
                "带案下访",
                "廉政建设",
                "思想政治洗礼",
                "执行不力",
                "政绩观",
                "典治乱",
                "铁包公",
                "集体资金案",
                "不为百姓",
                "中饱私囊",
                "买官",
                "卖官",
                "跑官",
                "作风",
                "保护伞",
                "倡廉",
                "公权",
                "公款",
                "勾结",
                "包庇",
                "双开",
                "双规",
                "吃拿",
                "大操大办",
                "官商",
                "官场",
                "官官相卫",
                "官官相护",
                "小金库",
                "廉政",
                "徇私",
                "情妇",
                "拿好处",
                "推诿",
                "收受",
                "暗箱操作",
                "潜规则",
                "空饷",
                "纵容亲属",
                "纵容配偶",
                "职务之便",
                "职权",
                "腐化",
                "草芥人命",
                "营私",
                "要官",
                "谋取私利",
                "贪官",
                "走形式",
                "越权",
                "违纪",
                "违规",
                "鱼肉百姓",
                "被免职",
                "包二奶",
                "包养情人",
                "包养情妇",
                "报假帐",
                "暴力取证",
                "被调查",
                "被举报",
                "纪委",
                "纪检",
                "干部",
                "被没收粮田",
                "被挖双眼",
                "被指侵占",
                "拨款退税款",
                "敛财",
                "干部戴名表",
                "腐化",
                "公车超标",
                "公务用车",
                "公务车",
                "公车私用",
                "公道何在",
                "公费旅游",
                "政策泄露",
                "官员出场费",
                "捞肥肉",
                "捞钱",
                "捞油水",
                "走穴",
                "虚报冒领",
                "瞒报",
                "谎报",
                "贿选",
                "利用职务",
                "职务便利",
                "职务之便",
                "乱罚款",
                "煤矿非法转让",
                "牟取私利",
                "弄虚作假",
                "骗取国家财政",
                "骗取荣誉",

                "欺压百姓",
                "欺压老百姓",
                "侵犯公私财产",

                "侵吞国有资产",

                "司法不公",
                "违法审批",

                "徇私枉法",
                "营私舞弊",
                "走后门",
                "撤职",
                "选举",
                "投诉政府",
                "有法不依",
                "暴力执法",
                "被查",
                "处分",
                "被罚",
                "开除党籍",
                "被免",
                "被停岗",
                "被停职",
                "被通报",
                "被问责",
                "撤职",
                "粗暴执法",
                "富人特权",
                "工车私用",
                "撤职",
                "富人特权",
                "工车私用",
                "官场灰色",
                "官犯串通",
                "黑幕",
                "黑箱操作",
                "换届乱象",
                "贿买",
                "伪造选票",
                "虚报票数",
                "接受调查",
                "乱作为",
                "瞒报",
                "慢作为",
                "没人管",
                "免职",
                "谋私利",
                "挪巨款",
                "涉嫌滥用",
                "涉嫌私用",
                "涉嫌滥用",
                "涉嫌私用",
                "职务侵占",
                "私放嫌犯",
                "私放疑犯",
                "私分国有资产",
                "贪腐",
                
                "选举乱象",
                "徇私舞弊",
                "玩忽职守",
                "问责",
                "以权压法",
                
                "遭查",
                "遭处罚",
                "遭免",
                "责令",
                "责问",
                "执法不人性",
                
                "检举",
                "遭查办",
                
                "遭撤职",
                "遭处分",
                "雅贿",
                "遭停岗",
                "遭停职",
                "假公济私",
                "局长被爆",
                "局长玩弄女性",
                
                
                "表决权",
                "不称职干部",
                "不合格党员",
                "涉嫌袒护",
                
                "顶风违纪",
                "福利式提拔",
                "干预办案",
                "告状无门",
                "官员变质",
                "官员粗口",
                "官员问责",
                "拉票",
                "权力滥用",
                "权力栽脏",
                "权钱交易",
                "权顷一方",
                "权权交易",
                "权色交易",
                "停职检查",
                "违法办案",
                "违纪办案",
                "选举权",
                "含冤而死",
                "一手遮天",
                "恶霸村长",
                "泄露案情",
                "举报信",
                "利用职务",
                "无证执法",
                
                "大贪官",
                "官商反腐",
                "官匪",
                "官商勾结",
                "官官",
                "官民对峙",
                "领导无能",
                
                "信访部门",
                "公款送礼",
                "依仗权势",
                "严重失职",
                "公款吃喝",
                "公款旅游",
                "不为民做主",
                "民告官",
                "收贿",
                "资产流失",
                "资金挪用",
                "超职数",
                
                "还有王法",
                "违宪",
                "选举",
                "选票",
                "贪赃枉法",
                "挪用公款",
                "换届",
                
                "政府收入",
                "政府被烧",
                "政府黑",
                "政治斗争",
                "政绩差",
                "知法犯法",
                "无案造案",
                
                "滥用公众权利",
                "形象工程",
                "待遇不公",
                "萝卜招聘",
                "告御状",
                "罚款指标",
                "罢免",
                "裸官",
                "国有资产流失",
                "国有资产贱卖",
                "不闻不问",
                "人事震荡",
                "欺压",
                "残害百姓",
                
                "档案造假",
                "百姓心声",
                "监管不利",
                "监管漏洞",
                "视而不管",
                "偷卖资产",
                
                "野蛮执法",
                "有关部门",
                "相关部门",
                
                "政府走形式",
                "表面功夫",
                "殴打群众",
                "通报批评",
                "文件泄露",
                "文件外泄",
                "文件透露",
                "文件走漏",
                "文件被泄",
                
                "政策发布",
                "政策公示",
                "政策公布",
                "政府公告",
                "省委书记",
                "省长",
                "省委常委",
                "市委书记",
                
                
                "市长",
                "市委常委",
                
                "县委书记",
                "县长",
                "区委书记",
                "区长",
                "公款吃喝",
               
                "账务模糊",
                "老虎苍蝇",
                "买官",
                "卖官",
                "腐败分子",
                "染指扶贫",
                "国家财政",
                "吃空饷",
                "弄虚作假",
                "损公肥私",
               
                "徇私舞弊",
                "人情案",
               
                "敛财有方",
                "账务不清",
                "项目缩水",
                "贫困户",
                "侵吞",
                "挪用",
                "腐败黑幕",
                "欺上瞒下",
                "胡作非为",
                "贪官",
                "倒卖",
                "高压线",
                "职务之便",
                "补贴款",
                "以权谋私",
                "财务问题",
                "官官相护",
                "权钱交易",
                "官二代",
                "配套资金",
                "违规提拔",
                "精准扶贫",
                "形同虚设",
                "懒政",
                "不作为",
                "面子工程",
                "百姓呼声",
                "强拆",
                "形同虚设",
                "包庇",
               
                "豪华办公楼",
                "打白条",
                "弱肉强食",
                "形象工程",
                "带病提拔",
                "为所欲为",
                "政府采购",
                "脱贫",
                "扶贫资金",
                "作秀",
                "贫困户",
                "违法违纪",
                "公车私用",
                "为人民服务",
                "人民公仆",
                "结党营私",
                "官僚主义",
                "职务犯罪",
                "暗箱操作",
                "私吞公款",
                "狗官",
                "渎职",
                "脱岗",
                "欺上瞒下",
                "实名举报",
                "三公经费",
                "优亲厚友",
                "吃拿卡要",
                "截留",
                "公款赌博",
                "公款走访",
                "无证执法",
                "扣押物品",
                "非法取缔",
               
                "利用职务之便",
                "公款吃喝",
                "监管不利",
                "滥用公众权利",
                "政府失诚信",
                "不为民做主",
                "执政能力",
                "官僚主义",
                "政绩",
                "拉帮结派",
                "武力镇压",
                "利用职权",
                '滥用职权',
              ],
              [
               
                '河',
                "索贿",
                "受贿",
                "贿赂",
                "行贿",
                "摄入",
                "贪污",
                "消息",
                "大贪",
                "贪官",
                "腐败",
                "巨贪",
                "巨贿",
                "不作为",
                "利用职权",
                "职权之便",

                "职权谋取",
                "职权牟取",
                "滥用权利",
                "贪污公款",
                "职权获利",
                "公款提成",
                "公款私用",

                "受处分",
                "巨额财产",
                "打击报复",
                "落马",
                "贪巨款",
                "挪用",
                "渎职",
                "不正之风",
                "严肃执纪",
                "义利观",
                "乱发钱物",
                "以权谋私",
                "优亲厚友",
                "依规治党",
                "侵害群众",
                "切身利益",
                "开除党籍",
                "党纪",
                "国法",
                "公私观",
                "包案协调",
                "包案查办",
                "包案督办",
                "公款旅游",
                "吃空饷",
                "合理诉求",
                "四风",
                "失职",
                "巡视组",
                "工作作风",
                "带案下访",
                "廉政建设",
                "思想政治洗礼",
                "执行不力",
                "政绩观",
                "典治乱",
                "铁包公",
                "集体资金案",
                "不为百姓",
                "中饱私囊",
                "买官",
                "卖官",
                "跑官",
                "作风",
                "保护伞",
                "倡廉",
                "公权",
                "公款",
                "勾结",
                "包庇",
                "双开",
                "双规",
                "吃拿",
                "大操大办",
                "官商",
                "官场",
                "官官相卫",
                "官官相护",
                "小金库",
                "廉政",
                "徇私",
                "情妇",
                "拿好处",
                "推诿",
                "收受",
                "暗箱操作",
                "潜规则",
                "空饷",
                "纵容亲属",
                "纵容配偶",
                "职务之便",
                "职权",
                "腐化",
                "草芥人命",
                "营私",
                "要官",
                "谋取私利",
                "贪官",
                "走形式",
                "越权",
                "违纪",
                "违规",
                "鱼肉百姓",
                "被免职",
                "包二奶",
                "包养情人",
                "包养情妇",
                "报假帐",
                "暴力取证",
                "被调查",
                "被举报",
                "纪委",
                "纪检",
                "干部",
                "被没收粮田",
                "被挖双眼",
                "被指侵占",
                "拨款退税款",
                "敛财",
                "干部戴名表",
                "腐化",
                "公车超标",
                "公务用车",
                "公务车",
                "公车私用",
                "公道何在",
                "公费旅游",
                "政策泄露",
                "官员出场费",
                "捞肥肉",
                "捞钱",
                "捞油水",
                "走穴",
                "虚报冒领",
                "瞒报",
                "谎报",
                "贿选",
                "利用职务",
                "职务便利",
                "职务之便",
                "乱罚款",
                "煤矿非法转让",
                "牟取私利",
                "弄虚作假",
                "骗取国家财政",
                "骗取荣誉",

                "欺压百姓",
                "欺压老百姓",
                "侵犯公私财产",

                "侵吞国有资产",

                "司法不公",
                "违法审批",

                "徇私枉法",
                "营私舞弊",
                "走后门",
                "撤职",
                "选举",
                "投诉政府",
                "有法不依",
                "暴力执法",
                "被查",
                "处分",
                "被罚",
                "开除党籍",
                "被免",
                "被停岗",
                "被停职",
                "被通报",
                "被问责",
                "撤职",
                "粗暴执法",
                "富人特权",
                "工车私用",
                "撤职",
                "富人特权",
                "工车私用",
                "官场灰色",
                "官犯串通",
                "黑幕",
                "黑箱操作",
                "换届乱象",
                "贿买",
                "伪造选票",
                "虚报票数",
                "接受调查",
                "乱作为",
                "瞒报",
                "慢作为",
                "没人管",
                "免职",
                "谋私利",
                "挪巨款",
                "涉嫌滥用",
                "涉嫌私用",
                "涉嫌滥用",
                "涉嫌私用",
                "职务侵占",
                "私放嫌犯",
                "私放疑犯",
                "私分国有资产",
                "贪腐",
                
                "选举乱象",
                "徇私舞弊",
                "玩忽职守",
                "问责",
                "以权压法",
                
                "遭查",
                "遭处罚",
                "遭免",
                "责令",
                "责问",
                "执法不人性",
                
                "检举",
                "遭查办",
                
                "遭撤职",
                "遭处分",
                "雅贿",
                "遭停岗",
                "遭停职",
                "假公济私",
                "局长被爆",
                "局长玩弄女性",
                
                
                "表决权",
                "不称职干部",
                "不合格党员",
                "涉嫌袒护",
                
                "顶风违纪",
                "福利式提拔",
                "干预办案",
                "告状无门",
                "官员变质",
                "官员粗口",
                "官员问责",
                "拉票",
                "权力滥用",
                "权力栽脏",
                "权钱交易",
                "权顷一方",
                "权权交易",
                "权色交易",
                "停职检查",
                "违法办案",
                "违纪办案",
                "选举权",
                "含冤而死",
                "一手遮天",
                "恶霸村长",
                "泄露案情",
                "举报信",
                "利用职务",
                "无证执法",
                
                "大贪官",
                "官商反腐",
                "官匪",
                "官商勾结",
                "官官",
                "官民对峙",
                "领导无能",
                
                "信访部门",
                "公款送礼",
                "依仗权势",
                "严重失职",
                "公款吃喝",
                "公款旅游",
                "不为民做主",
                "民告官",
                "收贿",
                "资产流失",
                "资金挪用",
                "超职数",
                
                "还有王法",
                "违宪",
                "选举",
                "选票",
                "贪赃枉法",
                "挪用公款",
                "换届",
                
                "政府收入",
                "政府被烧",
                "政府黑",
                "政治斗争",
                "政绩差",
                "知法犯法",
                "无案造案",
                
                "滥用公众权利",
                "形象工程",
                "待遇不公",
                "萝卜招聘",
                "告御状",
                "罚款指标",
                "罢免",
                "裸官",
                "国有资产流失",
                "国有资产贱卖",
                "不闻不问",
                "人事震荡",
                "欺压",
                "残害百姓",
                
                "档案造假",
                "百姓心声",
                "监管不利",
                "监管漏洞",
                "视而不管",
                "偷卖资产",
                
                "野蛮执法",
                "有关部门",
                "相关部门",
                
                "政府走形式",
                "表面功夫",
                "殴打群众",
                "通报批评",
                "文件泄露",
                "文件外泄",
                "文件透露",
                "文件走漏",
                "文件被泄",
                
                "政策发布",
                "政策公示",
                "政策公布",
                "政府公告",
                "省委书记",
                "省长",
                "省委常委",
                "市委书记",
                
                
                "市长",
                "市委常委",
                
                "县委书记",
                "县长",
                "区委书记",
                "区长",
                "公款吃喝",
               
                "账务模糊",
                "老虎苍蝇",
                "买官",
                "卖官",
                "腐败分子",
                "染指扶贫",
                "国家财政",
                "吃空饷",
                "弄虚作假",
                "损公肥私",
               
                "徇私舞弊",
                "人情案",
               
                "敛财有方",
                "账务不清",
                "项目缩水",
                "贫困户",
                "侵吞",
                "挪用",
                "腐败黑幕",
                "欺上瞒下",
                "胡作非为",
                "贪官",
                "倒卖",
                "高压线",
                "职务之便",
                "补贴款",
                "以权谋私",
                "财务问题",
                "官官相护",
                "权钱交易",
                "官二代",
                "配套资金",
                "违规提拔",
                "精准扶贫",
                "形同虚设",
                "懒政",
                "不作为",
                "面子工程",
                "百姓呼声",
                "强拆",
                "形同虚设",
                "包庇",
               
                "豪华办公楼",
                "打白条",
                "弱肉强食",
                "形象工程",
                "带病提拔",
                "为所欲为",
                "政府采购",
                "脱贫",
                "扶贫资金",
                "作秀",
                "贫困户",
                "违法违纪",
                "公车私用",
                "为人民服务",
                "人民公仆",
                "结党营私",
                "官僚主义",
                "职务犯罪",
                "暗箱操作",
                "私吞公款",
                "狗官",
                "渎职",
                "脱岗",
                "欺上瞒下",
                "实名举报",
                "三公经费",
                "优亲厚友",
                "吃拿卡要",
                "截留",
                "公款赌博",
                "公款走访",
                "无证执法",
                "扣押物品",
                "非法取缔",
               
                "利用职务之便",
                "公款吃喝",
                "监管不利",
                "滥用公众权利",
                "政府失诚信",
                "不为民做主",
                "执政能力",
                "官僚主义",
                "政绩",
                "拉帮结派",
                "武力镇压",
                "利用职权",
                '滥用职权',
              ],
          ],
          [
            [
               
                '序言',
                "索贿",
                "受贿",
                "贿赂",
                "行贿",
                "摄入",
                "贪污",
                "消息",
                "大贪",
                "贪官",
                "腐败",
                "巨贪",
                "巨贿",
                "不作为",
                "利用职权",
                "职权之便",

                "职权谋取",
                "职权牟取",
                "滥用权利",
                "贪污公款",
                "职权获利",
                "公款提成",
                "公款私用",

                "受处分",
                "巨额财产",
                "打击报复",
                "落马",
                "贪巨款",
                "挪用",
                "渎职",
                "不正之风",
                "严肃执纪",
                "义利观",
                "乱发钱物",
                "以权谋私",
                "优亲厚友",
                "依规治党",
                "侵害群众",
                "切身利益",
                "开除党籍",
                "党纪",
                "国法",
                "公私观",
                "包案协调",
                "包案查办",
                "包案督办",
                "公款旅游",
                "吃空饷",
                "合理诉求",
                "四风",
                "失职",
                "巡视组",
                "工作作风",
                "带案下访",
                "廉政建设",
                "思想政治洗礼",
                "执行不力",
                "政绩观",
                "典治乱",
                "铁包公",
                "集体资金案",
                "不为百姓",
                "中饱私囊",
                "买官",
                "卖官",
                "跑官",
                "作风",
                "保护伞",
                "倡廉",
                "公权",
                "公款",
                "勾结",
                "包庇",
                "双开",
                "双规",
                "吃拿",
                "大操大办",
                "官商",
                "官场",
                "官官相卫",
                "官官相护",
                "小金库",
                "廉政",
                "徇私",
                "情妇",
                "拿好处",
                "推诿",
                "收受",
                "暗箱操作",
                "潜规则",
                "空饷",
                "纵容亲属",
                "纵容配偶",
                "职务之便",
                "职权",
                "腐化",
                "草芥人命",
                "营私",
                "要官",
                "谋取私利",
                "贪官",
                "走形式",
                "越权",
                "违纪",
                "违规",
                "鱼肉百姓",
                "被免职",
                "包二奶",
                "包养情人",
                "包养情妇",
                "报假帐",
                "暴力取证",
                "被调查",
                "被举报",
                "纪委",
                "纪检",
                "干部",
                "被没收粮田",
                "被挖双眼",
                "被指侵占",
                "拨款退税款",
                "敛财",
                "干部戴名表",
                "腐化",
                "公车超标",
                "公务用车",
                "公务车",
                "公车私用",
                "公道何在",
                "公费旅游",
                "政策泄露",
                "官员出场费",
                "捞肥肉",
                "捞钱",
                "捞油水",
                "走穴",
                "虚报冒领",
                "瞒报",
                "谎报",
                "贿选",
                "利用职务",
                "职务便利",
                "职务之便",
                "乱罚款",
                "煤矿非法转让",
                "牟取私利",
                "弄虚作假",
                "骗取国家财政",
                "骗取荣誉",

                "欺压百姓",
                "欺压老百姓",
                "侵犯公私财产",

                "侵吞国有资产",

                "司法不公",
                "违法审批",

                "徇私枉法",
                "营私舞弊",
                "走后门",
                "撤职",
                "选举",
                "投诉政府",
                "有法不依",
                "暴力执法",
                "被查",
                "处分",
                "被罚",
                "开除党籍",
                "被免",
                "被停岗",
                "被停职",
                "被通报",
                "被问责",
                "撤职",
                "粗暴执法",
                "富人特权",
                "工车私用",
                "撤职",
                "富人特权",
                "工车私用",
                "官场灰色",
                "官犯串通",
                "黑幕",
                "黑箱操作",
                "换届乱象",
                "贿买",
                "伪造选票",
                "虚报票数",
                "接受调查",
                "乱作为",
                "瞒报",
                "慢作为",
                "没人管",
                "免职",
                "谋私利",
                "挪巨款",
                "涉嫌滥用",
                "涉嫌私用",
                "涉嫌滥用",
                "涉嫌私用",
                "职务侵占",
                "私放嫌犯",
                "私放疑犯",
                "私分国有资产",
                "贪腐",
                
                "选举乱象",
                "徇私舞弊",
                "玩忽职守",
                "问责",
                "以权压法",
                
                "遭查",
                "遭处罚",
                "遭免",
                "责令",
                "责问",
                "执法不人性",
                
                "检举",
                "遭查办",
                
                "遭撤职",
                "遭处分",
                "雅贿",
                "遭停岗",
                "遭停职",
                "假公济私",
                "局长被爆",
                "局长玩弄女性",
                
                
                "表决权",
                "不称职干部",
                "不合格党员",
                "涉嫌袒护",
                
                "顶风违纪",
                "福利式提拔",
                "干预办案",
                "告状无门",
                "官员变质",
                "官员粗口",
                "官员问责",
                "拉票",
                "权力滥用",
                "权力栽脏",
                "权钱交易",
                "权顷一方",
                "权权交易",
                "权色交易",
                "停职检查",
                "违法办案",
                "违纪办案",
                "选举权",
                "含冤而死",
                "一手遮天",
                "恶霸村长",
                "泄露案情",
                "举报信",
                "利用职务",
                "无证执法",
                
                "大贪官",
                "官商反腐",
                "官匪",
                "官商勾结",
                "官官",
                "官民对峙",
                "领导无能",
                
                "信访部门",
                "公款送礼",
                "依仗权势",
                "严重失职",
                "公款吃喝",
                "公款旅游",
                "不为民做主",
                "民告官",
                "收贿",
                "资产流失",
                "资金挪用",
                "超职数",
                
                "还有王法",
                "违宪",
                "选举",
                "选票",
                "贪赃枉法",
                "挪用公款",
                "换届",
                
                "政府收入",
                "政府被烧",
                "政府黑",
                "政治斗争",
                "政绩差",
                "知法犯法",
                "无案造案",
                
                "滥用公众权利",
                "形象工程",
                "待遇不公",
                "萝卜招聘",
                "告御状",
                "罚款指标",
                "罢免",
                "裸官",
                "国有资产流失",
                "国有资产贱卖",
                "不闻不问",
                "人事震荡",
                "欺压",
                "残害百姓",
                
                "档案造假",
                "百姓心声",
                "监管不利",
                "监管漏洞",
                "视而不管",
                "偷卖资产",
                
                "野蛮执法",
                "有关部门",
                "相关部门",
                
                "政府走形式",
                "表面功夫",
                "殴打群众",
                "通报批评",
                "文件泄露",
                "文件外泄",
                "文件透露",
                "文件走漏",
                "文件被泄",
                
                "政策发布",
                "政策公示",
                "政策公布",
                "政府公告",
                "省委书记",
                "省长",
                "省委常委",
                "市委书记",
                
                
                "市长",
                "市委常委",
                
                "县委书记",
                "县长",
                "区委书记",
                "区长",
                "公款吃喝",
               
                "账务模糊",
                "老虎苍蝇",
                "买官",
                "卖官",
                "腐败分子",
                "染指扶贫",
                "国家财政",
                "吃空饷",
                "弄虚作假",
                "损公肥私",
               
                "徇私舞弊",
                "人情案",
               
                "敛财有方",
                "账务不清",
                "项目缩水",
                "贫困户",
                "侵吞",
                "挪用",
                "腐败黑幕",
                "欺上瞒下",
                "胡作非为",
                "贪官",
                "倒卖",
                "高压线",
                "职务之便",
                "补贴款",
                "以权谋私",
                "财务问题",
                "官官相护",
                "权钱交易",
                "官二代",
                "配套资金",
                "违规提拔",
                "精准扶贫",
                "形同虚设",
                "懒政",
                "不作为",
                "面子工程",
                "百姓呼声",
                "强拆",
                "形同虚设",
                "包庇",
               
                "豪华办公楼",
                "打白条",
                "弱肉强食",
                "形象工程",
                "带病提拔",
                "为所欲为",
                "政府采购",
                "脱贫",
                "扶贫资金",
                "作秀",
                "贫困户",
                "违法违纪",
                "公车私用",
                "为人民服务",
                "人民公仆",
                "结党营私",
                "官僚主义",
                "职务犯罪",
                "暗箱操作",
                "私吞公款",
                "狗官",
                "渎职",
                "脱岗",
                "欺上瞒下",
                "实名举报",
                "三公经费",
                "优亲厚友",
                "吃拿卡要",
                "截留",
                "公款赌博",
                "公款走访",
                "无证执法",
                "扣押物品",
                "非法取缔",
               
                "利用职务之便",
                "公款吃喝",
                "监管不利",
                "滥用公众权利",
                "政府失诚信",
                "不为民做主",
                "执政能力",
                "官僚主义",
                "政绩",
                "拉帮结派",
                "武力镇压",
                "利用职权",
                '滥用职权',
                
              ],
        ],
        ];
      },
    },
  };
}
